import Request from "../lib/request";
import {browserName, fullBrowserVersion, osName, osVersion} from "react-device-detect";
import uniqueDeviceId from "../lib/generateUniqueDeviceId";

const baseUrl = process.env.REACT_APP_API_URL;
const platform = process.env.REACT_APP_CLIENT_ID;
export const getList = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/feedbacks`,
    needToken: true
  });
};

export const getTitles = () => {
  return Request({
    method: "get",
    url: `${baseUrl}/feedback/titles`,
    needToken: true
  });
};

export const get = id => {
  return Request({
    method: "get",
    url: `${baseUrl}/feedbacks/${id}`,
    needToken: true
  });
};
export const read = id => {
  return Request({
    method: "get",
    url: `${baseUrl}/feedback/${id}/read`,
    needToken: true
  });
};

export const store = data => {
  return Request({
    method: "post",
    url: `${baseUrl}/feedbacks`,
    needToken: true,
    data:
    {...data,
      device_info:{
        serial:uniqueDeviceId(),
        platform: platform,
        os_version: `${osName}_${osVersion}`,
        model: `${browserName}_${fullBrowserVersion}`
      }
    }
  });
};

export const storeImage = (image , id) => {
  let formData = new FormData();
  formData.append('image', image);
  return Request({
    method: "post",
    url: `${baseUrl}/feedbacks/${id}/images`,
    needToken: true,
    headers: {
      'Content-Type': 'multipart/forms-data'
    },
    data:formData
  });
};

export const score = (id, score) => {
  return Request({
    method: "post",
    url: `${baseUrl}/feedback/${id}/score`,
    needToken: true,
    data:{
      score
    }
  });
};
